<template>
    <div id="cardDetailsInviteProcessor" style="max-height: 100vh !important; overflow-y: hidden;">
      <template v-if="providerTypeId === 1">
        <sumup-widget v-model="widgetStatus" :checkout-id="providerReference"></sumup-widget>
      </template>
    </div>
</template>

<script>
import { StatusEmitterMixin } from '@/mixins/Shared/StatusEmitterMixin'
import SumUpWidget from './Widgets/SumUpWidget.vue'

export default {
  name: 'CardDetailsInviteProcessor',
  mixins: [StatusEmitterMixin],
  props: {
    invite: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      widgetStatus: {}
    }
  },
  computed: {
    providerTypeId () {
      return this.invite.providerTypeId
    },
    providerReference () {
      return this.invite.providerReference
    },
    error () {
      return this.widgetStatus ? this.widgetStatus.error : ''
    },
    loading () {
      return this.widgetStatus ? this.widgetStatus.loading : false
    },
    completed () {
      return this.widgetStatus ? this.widgetStatus.completed : false
    },
    status () {
      return {
        error: this.error,
        loading: this.loading,
        completed: this.completed
      }
    }
  },
  components: {
    'sumup-widget': SumUpWidget
  }
}
</script>
